import Page from "./Page";
import { AMSTERDAM, NEW_YORK, SAN_JOSE, SINGAPORE } from "./Constants";
import "./Datacenter.css";


export default class Datacenter extends Page {
   datacenters = {}


   constructor( props ) {
      super( props );

      this.datacenters[AMSTERDAM] = ( // https://www.leaseweb.com/certifications
         <div className="Datacenter">
            <h1>Amsterdam Datacenter</h1>

            <ul>
               <li>17 carriers with diverse fiber</li>
               <li>Autonomous A+B power supplies</li>
               <li>UPS and generator back-up power</li>
               <li>VESDA fire suppression system as well as fire resistant walls</li>
               <li><a href="https://comsecglobal.com/services-products/pci-dss" target="_blank">
                  Payment Card Industry Data Security Standard (PCI DSS)</a> certifications 9.1 to 9.4, 9.10, 10.6.1, 11.1.2, 12.1, 12.2, 12.4 to 12.10.</li>
               <li><a href="http://www.iso.org/iso/home/standards/management-standards/iso27001.htm" target="_blank">
                  ISO 27001 certified</a></li>
               <li>HIPAA compliance</li>
            </ul>
         </div>
      );

      this.datacenters[NEW_YORK] = ( // https://www.zayo.com/wp-content/uploads/2015/08/New-York-60-Hudson-Street-1.pdf
         <div className="Datacenter">
            <h1>New York Datacenter</h1>

            <ul>
               <li>34 carriers with diverse fiber</li>
               <li>4 generators, 2N redundancy</li>
               <li>2N UPS redundancy</li>
               <li>Cross zoned smoke detectors; dry pipes</li>
               <li>Key card, alarm and video surveillance</li>
               <li>SSAE 16 SOC 1 Type 2, SOC 2 Type 2, SOC 3 compliance</li>
               <li>HIPAA compliance</li>
            </ul>
         </div>
      );

      this.datacenters[SAN_JOSE] = ( // http://he.net/colocation.html
         <div className="Datacenter">
            <h1>San Jose Datacenter</h1>

            <ul>
               <li>2 Internet exchange points (SFMIX and AMS-IX Bay)</li>
               <li>7 carriers with diverse fiber</li>
               <li>Diverse A+B power available (fully separate PDUs, panels, transformers, generators)</li>
               <li>UPS and generator back-up power</li>
               <li>Individually locked cabinets</li>
               <li>Custom designed video surveillance of every cabinet</li>
               <li>Card keyed doors and other onsite security measures</li>
            </ul>
         </div>
      );

      this.datacenters[SINGAPORE] = ( //https://www.singtel.com/business/enterprise-solutions/singtel-data-centre/our-facilities/dc-west
         <div className="Datacenter">
            <h1>Singapore Datacenter</h1>

            <ul>
               <li>3 diverse fiber paths and 2 separate communications risers</li>
               <li>Diverse and physically isolated power systems</li>
               <li>Emergency generator power</li>
               <li>Palm vein biometric access</li>
               <li>Round-the-clock closed circuit TV (CCTV) monitoring with recording</li>
               <li>Regular security patrols</li>
            </ul>
         </div>
      );
   }


   render() {
      return this.datacenters[this.props.params.id];
   }
}



// WEBPACK FOOTER //
// ./src/Datacenter.js